import * as RadixCheckbox from '@radix-ui/react-checkbox';
import classNames from 'classnames';
import { useId, useRef } from 'react';
import styles from './Checkbox.module.scss';

interface ICheckboxProps {
  checked?: boolean | 'indeterminate';
  onCheckedChange?: (checked: boolean | 'indeterminate', event?: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  label?: string;
  id?: string;
  name?: string;
  required?: boolean;
  className?: string;
  'aria-label'?: string;
}

export function Checkbox({
  checked,
  onCheckedChange,
  disabled,
  label,
  id,
  name,
  required,
  className,
  'aria-label': ariaLabel,
}: ICheckboxProps) {
  'use memo';

  const generatedId = useId();
  const resolvedId = id ?? generatedId;

  const lastEventRef = useRef<React.MouseEvent<HTMLButtonElement> | undefined>(undefined);

  return (
    <div className={classNames(styles.wrapper, { [styles.disabled]: disabled }, className)}>
      <RadixCheckbox.Root
        checked={checked}
        onClick={event => {
          lastEventRef.current = event;
        }}
        onCheckedChange={next => onCheckedChange?.(next, lastEventRef.current)}
        disabled={disabled}
        id={resolvedId}
        name={name}
        required={required}
        className={styles.checkbox}
        aria-label={ariaLabel}
      >
        <RadixCheckbox.Indicator className={styles.indicator}>
          {checked === 'indeterminate' ? (
            <img src="/images/checkbox-minus.svg" alt="" width={10} height={10} />
          ) : (
            <img src="/images/checkbox-check.svg" alt="" width={10} height={10} />
          )}
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      {label && (
        <label htmlFor={resolvedId} className={styles.label}>
          {label}
        </label>
      )}
    </div>
  );
}
